import { RouterSelectors } from '@next/core-lib/router-store';
import { createSelector } from '@ngrx/store';
import {
  SalesOrderPeriod,
  TreatmentType,
} from 'src/app/sales-order-period/models/sales-order-period.models';
import {
  selectSalesOrderPeriods,
  selectPastSalesOrderPeriods,
} from 'src/app/sales-order-period/store/sales-order-period.selectors';

import { selectNitrogenEffectivityForAidAdvice } from './nitrogen-effectivity.selectors';
import { selectEditingAdvice } from './selectors';
import { CropAid } from '../../crop-aid/crop-aid.model';
import { selectCropAids } from '../../crop-aid/store/crop-aid.selectors';
import { CropFieldAdvice, TreatmentWithNitrogenEffectivity } from '../../shared/models';
import { sortTreatments } from '../../shared/util/sort-treatments';

export const selectEditingTreatments = createSelector(
  selectEditingAdvice,
  RouterSelectors.getRouteParam('treatmentType'),
  selectSalesOrderPeriods,
  selectPastSalesOrderPeriods,
  selectCropAids,
  (
    advice: CropFieldAdvice,
    editingTreatmentType: TreatmentType,
    salesOrderPeriods: SalesOrderPeriod[],
    pastSalesOrderPeriods: SalesOrderPeriod[],
    cropAids: CropAid[],
  ): TreatmentWithNitrogenEffectivity[] =>
    editingTreatmentType && advice?.treatments
      ? sortTreatments(
          advice.treatments.filter((treatment) => treatment.treatmentType === editingTreatmentType),
        ).map((treatment) => ({
          ...treatment,
          isAnExecutedTreatment: false,
          aidAdvices: treatment.aidAdvices.map((aidAdvice) => ({
            ...aidAdvice,
            ...selectNitrogenEffectivityForAidAdvice({
              periodId: treatment.periodId,
              aidAdvice,
              isAnExecutedTreatment: false,
            }).projector(salesOrderPeriods, pastSalesOrderPeriods, cropAids),
          })),
        }))
      : [],
);
